import React, { Component } from 'react';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Box,
  Button,
  CircularProgress,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import { Slide } from '@material-ui/core';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
import surveyTemplate from "./surveyTemplate";
import { apiPath } from 'api';
import { generalAuthTokenHeader } from '__helpers/auth-header';
import { getActiveFacilityId } from '__helpers/activeFacility';
import { userService } from '_services/user.service';
import SurveyGeneralPreview from './SurveyGeneralPreview';
import close from '../../../assets/img/close.svg';
import functionStatus from '../../../assets/img/function.jpg';
import medication from '../../../assets/img/medication.jpg';
import other from '../../../assets/img/other.jpg';
import social from '../../../assets/img/social.jpg';
import pain from '../../../assets/img/pain.jpg';
import congnitive from '../../../assets/img/congnitive.jpg';
import navbar from '../../../assets/img/navbar.svg';
import deleteIcons from '../../../assets/img/delete.svg';
import next from '../../../assets/img/next.svg';
import back from '../../../assets/img/back.svg';
import css from '../../../assets/css/addnewsurvey.css';
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="right" ref={ref} {...props} />;
});

class AddNewSurvey extends Component {
  constructor(props) {
    super(props);
    let spinner = document.getElementById("loadingSpinner");
    let userinfo = JSON.parse(localStorage.getItem("_user_info"));

    this.state = {
      modalStatus: false, // Controls modal open/close
      confirmModalMessage: '',
      confirmModalStatus: false,
      loading: false,
      showPreview: false,
      previewPayload: null,
      surveys: [],
      spinner: spinner,
      surveyData: [], // Store the survey data here
      dischargePlannerId:
        (userinfo.dischargePlanner && userinfo.dischargePlanner.id) ||
        (userinfo && userinfo.createdById) ||
        null,
      questions: [
        {
          questionText: '',
          inputTypeId: null,
          options: [],
          required:false,
          weightage: 0,
           questionOrder: null, 
        }
      ],    
      currentDomainIndex: 0,
      domains: [],
      domainQuestions: [[], [], [], [], []],
      otherQuestions:[],
      surveyTitle: '',
     surveyDescription: '',
     introText:'',
     closingText: 'Thank you for your time!',
      errors: []
    };
  }
validateQuestions = () => {
  let formErrors = {};

  // validate title
  if (!this.state.surveyTitle.trim()) {
    formErrors.surveyTitle = "Form name is required";
  }

  // check if we are in other domain
  const isOtherDomain = this.state.currentDomainIndex === this.state.domains.length;
  const questionsToValidate = isOtherDomain
    ? this.state.otherQuestions
    : this.state.questions;

  // validate questions
  const questionErrors = questionsToValidate.map((q) => {
    let err = {};

    if (isOtherDomain) {
      // special case: allow both empty
      const hasText = q.questionText && q.questionText.trim();
      const hasType = q.type && q.type.trim();

      if (hasText && !hasType) {
        err.type = "Please select a type";
      }
      if (hasType && !hasText) {
        err.questionText = "Question text is required";
      }

      // if both filled, validate normally
      if (hasText && hasType) {
        if (
          (q.type === "Multiple Choice" || q.type === "Exclusive Choice") &&
          q.options.some((opt) => !opt || !opt.optionText?.trim())
        ) {
          err.options = "All options must be filled";
        }
      }
    } else {
      // normal domain: both are always required
      if (!q.questionText || !q.questionText.trim()) {
        err.questionText = "Question text is required";
      }
      if (!q.type) {
        err.type = "Please select a type";
      }
      if (
        (q.type === "Multiple Choice" || q.type === "Exclusive Choice") &&
        q.options.some((opt) => !opt || !opt.optionText?.trim())
      ) {
        err.options = "All options must be filled";
      }
    }

    return err;
  });

  // update errors in state
  if (isOtherDomain) {
    this.setState({ otherErrors: questionErrors, formErrors });
  } else {
    this.setState({ errors: questionErrors, formErrors });
  }

  // overall validation success
  return (
    Object.keys(formErrors).length === 0 &&
    questionErrors.every((err) => Object.keys(err).length === 0)
  );
};




  // Method to open the modal
  openSurveyModal = () => {
    this.setState({ modalStatus: true });
  };

  // Method to close the modal
  modalClose = () => {
    this.setState({ modalStatus: false });
  };

  // Handle question text input change
  handleQuestionChange = (index, event) => {
    const newQuestions = [...this.state.questions];
    newQuestions[index].questionText = event.target.value;
    this.setState({ questions: newQuestions });
  };


handleTypeChange = (qIndex, e) => {
  const newQuestions = [...this.state.questions];
  const selectedType = e.target.value;

  const selectedTypeDetails = this.state.surveys.find(
    survey => survey.type === selectedType
  );

  newQuestions[qIndex].type = selectedType;
  newQuestions[qIndex].inputTypeId = selectedTypeDetails ? selectedTypeDetails.id : null;
  newQuestions[qIndex].inputTypeName = selectedTypeDetails
    ? selectedTypeDetails.inputTypeName || selectedType
    : selectedType;

  // Reset options based on the selected type
  if (selectedType === 'Multiple Choice' || selectedType === 'Exclusive Choice') {
    newQuestions[qIndex].options = [{ optionText: 'Option 1', optionId: null }]; // Always 1 option
  } else if (selectedType === 'Rating') {
    newQuestions[qIndex].options = [
      { optionId: null, optionText: '1' },
      { optionId: null, optionText: '2' },
      { optionId: null, optionText: '3' },
      { optionId: null, optionText: '4' },
      { optionId: null, optionText: '5' }
    ]; // Always 5 options
  } else {
    newQuestions[qIndex].options = []; // Clear for other types
  }

  const isOtherDomain = this.state.currentDomainIndex === this.state.domains.length;

  if (isOtherDomain) {
    this.setState({
      questions: newQuestions,
      otherQuestions: newQuestions
    });
  } else {
    const updatedDomainQuestions = [...this.state.domainQuestions];
    updatedDomainQuestions[this.state.currentDomainIndex] = newQuestions;
    this.setState({
      questions: newQuestions,
      domainQuestions: updatedDomainQuestions
    });
  }
};

  
  // Handle option input change for checkbox/radio types
  // handleOptionChange = (qIndex, oIndex, event) => {
  //   const newQuestions = [...this.state.questions];
  //   newQuestions[qIndex].options[oIndex].optionText = event.target.value;

  //   const isOtherDomain = this.state.currentDomainIndex === this.state.domains.length;

  //   if (isOtherDomain) {
  //     this.setState({
  //       questions: newQuestions,
  //       otherQuestions: newQuestions
  //     });
  //   } else {
  //     const updatedDomainQuestions = [...this.state.domainQuestions];
  //     updatedDomainQuestions[this.state.currentDomainIndex] = newQuestions;
  //     this.setState({
  //       questions: newQuestions,
  //       domainQuestions: updatedDomainQuestions
  //     });
  //   }
  // };

  handleOptionChange = (qIndex, oIndex, event) => {
  const newQuestions = [...this.state.questions];

  if (typeof newQuestions[qIndex].options[oIndex] === "string") {
    newQuestions[qIndex].options[oIndex] = { optionText: "" };
  }

  newQuestions[qIndex].options[oIndex].optionText = event.target.value;

  const isOtherDomain = this.state.currentDomainIndex === this.state.domains.length;

  if (isOtherDomain) {
    this.setState({
      questions: newQuestions,
      otherQuestions: newQuestions
    });
  } else {
    const updatedDomainQuestions = [...this.state.domainQuestions];
    updatedDomainQuestions[this.state.currentDomainIndex] = newQuestions;
    this.setState({
      questions: newQuestions,
      domainQuestions: updatedDomainQuestions
    });
  }
};


  // Add a new option for checkbox/radio type
  addOption = (qIndex) => {
    const newQuestions = [...this.state.questions];
    newQuestions[qIndex].options.push('');
    this.setState({ questions: newQuestions });
  };

  // Add a new question
  addQuestion = () => {
    const newQuestions = [...this.state.questions];
    newQuestions.push({ questionText: '',inputTypeId: null,  options: [], weightage: 0, required: false,questionOrder: this.state.questions.length + 1, });
    const updatedDomainQuestions = [...this.state.domainQuestions];
    updatedDomainQuestions[this.state.currentDomainIndex] = newQuestions;
  
    this.setState({
      questions: newQuestions,
      domainQuestions: updatedDomainQuestions
    });
  };
  handleWeightageChange = (index, event) => {
    const newQuestions = [...this.state.questions];
    newQuestions[index].weightage = event.target.value;
    this.setState({ questions: newQuestions });
  };
  handleRequiredChange = (index) => {
    const newQuestions = [...this.state.questions];
    newQuestions[index].required = !newQuestions[index].required;
    this.setState({ questions: newQuestions });
  };
  

  // Submit survey data
  handleSurveySubmit = () => {
    console.log('Survey Submitted:', this.state.questions);
    this.setState({ modalStatus: false }); // Close modal after submission
  };

renderInputPreview = (type, options = [], qIndex = 0) => {
  // Normalize options to always be objects
  const normalizedOptions = options.map(option => {
    if (typeof option === 'string') {
      return { optionText: option, optionId: option };
    }
    return option;
  });

  switch (type) {
    case 'Short Answer':
      return <input type="text" placeholder="Short Answer" style={{ width: '25%',  border: '1px solid #ccc',
      padding: '10px',
      marginBottom: '20px',
      borderRadius: '8px',
      height: '40px' }}/>;

    case 'Paragraph':
      return <textarea placeholder="Paragraph" style={{ width: '25%',  border: '1px solid #ccc',
      padding: '10px',
      marginBottom: '20px',
      borderRadius: '8px',
      height: '40px' }}></textarea>;

    case 'Multiple Choice':
      return options.length > 0 ? options.map((option, index) => {
        // Safely get the display text
        const displayText = typeof option === 'object' ? option.optionText : option;
        return (
          <div key={index}>
            <input type="checkbox" id={`option-${qIndex}-${index}`} />
            <label htmlFor={`option-${qIndex}-${index}`} style={{ marginLeft: '10px' }}>
              {displayText} {/* Render just the text */}
            </label>
          </div>
        );
      }) : <p style={{ color: 'gray' }}>No options added.</p>;

    case 'Exclusive Choice':
      return options.length > 0 ? options.map((option, index) => {
        // Safely get the display text
        const displayText = typeof option === 'object' ? option.optionText : option;
        return (
          <div key={index}>
            <input type="radio" name={`group-${qIndex}`} id={`option-${qIndex}-${index}`} />
            <label htmlFor={`option-${qIndex}-${index}`} style={{ marginLeft: '10px' }}>
              {displayText} {/* Render just the text */}
            </label>
          </div>
        );
      }) : <p style={{ color: 'gray' }}>No options added.</p>;
    case 'Rating':
      return (
        <div style={{ display: 'flex', alignItems: 'center', gap: '130px' }}>
          <span style={{ fontWeight: 'bold' }}>Poor</span>
          {normalizedOptions.map((option, index) => (
            <label key={option.optionId ?? index} style={{ display: 'flex', alignItems: 'center' }}>
              <input
                type="radio"
                name={`rating-${this.state.currentQuestionIndex}`}
                value={option.optionText}
                style={{ paddingLeft: '10px' }}
              />
              <span style={{ marginLeft: '10px', fontWeight:'500' }}>{option.optionText}</span>
            </label>
          ))}
          <span style={{ fontWeight: 'bold' }}>Excellent</span>
        </div>
      );

    default:
      return null;
  }
};
          
  handleTitleChange = (e) => {
    this.setState({ surveyTitle: e.target.value });
  };
  
  handleDescriptionChange = (e) => {
    this.setState({ surveyDescription: e.target.value });
  };
  handleClosingTextChange = (e) => {
    this.setState({ closingText: e.target.value });
  };
  onDragEnd = (result) => {
    if (!result.destination) return;
  
    const items = Array.from(this.state.questions);
    const [reorderedItem] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, reorderedItem);
  
    // Update the order field for each question after reordering
    const updatedQuestions = items.map((question, index) => {
      question.questionOrder = index + 1; // Set order to be the new index + 1 (1-based index)
      return question;
    });
  
    this.setState({ questions: updatedQuestions });
  };
  
  removeOption = (qIndex, oIndex) => {
    const newQuestions = [...this.state.questions];
    newQuestions[qIndex].options.splice(oIndex, 1);
    this.setState({ questions: newQuestions });
  };
  
  async fetchInputTypes() {
    this.state.spinner.removeAttribute("hidden", "true");
  
    let showNotification = {};
    const apiUrl = apiPath.GetAllInputType;
  
    try {
      const response = await fetch(apiUrl, {
        method: "GET",
        headers: generalAuthTokenHeader(),
      });
  
      if (response.status === 400) {
        showNotification = { title: "Input Types", message: "Bad Request", type: "danger" };
      } else if (response.status === 401) {
        userService.logout();
        window.location.reload(true);
      } else if (!response.ok) {
        showNotification = { title: "Input Types", message: "Error fetching data", type: "danger" };
      }
  
      const data = await response.json();
      console.log("Input Types Fetched: ", data);
  
      // 🔥 Map the API response name to internal type
      const mappedData = data.map(item => {
        let type = '';
        if (item.name === 'Short Answer') type = 'Short Answer';
        else if (item.name === 'Paragraph') type = 'Paragraph';
        else if (item.name === 'Exclusive Choice') type = 'Exclusive Choice';
        else if (item.name === 'Multiple Choice') type = 'Multiple Choice';
        else if (item.name === 'Rating') type = 'Rating';
      
        return {
          ...item,
          type: type
        };
      });
    
      // Sort so that 'input' (Short Answer) comes first
      mappedData.sort((a, b) => (a.type === 'input' ? -1 : b.type === 'input' ? 1 : 0));
      
      this.setState({ surveys: mappedData });
      
  
      if (showNotification.title) userService.showNotification(showNotification);
    } catch (error) {
      console.error("Error fetching input types", error);
      showNotification = { title: "Input Types", message: "Server Error", type: "danger" };
      userService.showNotification(showNotification);
    }
  
    this.state.spinner.setAttribute("hidden", "true");
  }
  async fetchDomain() {
    this.state.spinner.removeAttribute("hidden", "true");
  
    let showNotification = {};
    const apiUrl = apiPath.GetAllDomain;
  
    try {
      const response = await fetch(apiUrl, {
        method: "GET",
        headers: generalAuthTokenHeader(),
      });
  
      if (response.status === 400) {
        showNotification = { title: "Input Types", message: "Bad Request", type: "danger" };
      } else if (response.status === 401) {
        userService.logout();
        window.location.reload(true);
      } else if (!response.ok) {
        showNotification = { title: "Input Types", message: "Error fetching data", type: "danger" };
      }
  
      const data = await response.json();
      console.log("All Domain Fetched: ", data);
  
    
      
     
      
      this.setState({ domains: data });
      
  
      if (showNotification.title) userService.showNotification(showNotification);
    } catch (error) {
      console.error("Error fetching input types", error);
      showNotification = { title: "Input Types", message: "Server Error", type: "danger" };
      userService.showNotification(showNotification);
    }
  
    this.state.spinner.setAttribute("hidden", "true");
  }
  
    
    componentDidMount() {
      this.fetchInputTypes();
      this.fetchDomain();
    }
    
    async submitSurveyForm() {
       const isValid = this.validateQuestions();
  if (!isValid) {
    console.log("Validation failed, cannot move to next domain");
    return; // stop if validation fails
  }
      this.state.spinner.removeAttribute("hidden");
    
      const updatedDomainQuestions = [...this.state.domainQuestions];
//  if (this.validateQuestions()) {
//     console.log("✅ All good, submit:", this.state.questions);
//   } else {
//     console.log("❌ Errors:", this.state.errors);
//   }
      // Always save current questions before submission
      if (this.state.currentDomainIndex === this.state.domains.length) {
        // Other Domain
        await new Promise(resolve => this.setState({ otherQuestions: this.state.questions }, resolve));
      } else {
        updatedDomainQuestions[this.state.currentDomainIndex] = this.state.questions;
      }
      const normalizedDomainQuestions = updatedDomainQuestions.map((domainQuestions = [], domainIndex) =>
        domainQuestions.map(({ type, ...q }) => ({
          ...q,
          // required: domainIndex === 0 ? false : (typeof q.required === 'boolean' ? q.required : false),
          required: typeof q.required === 'boolean' ? q.required : false,
          options: Array.isArray(q.options)
            ? q.options.map(opt => {
                if (typeof opt === 'string') return { optionText: opt };
                if (opt && typeof opt === 'object' && 'optionText' in opt) return opt;
                return { optionText: String(opt) };
              })
            : [],
        }))
      );
      
      const normalizedOtherQuestions = (this.state.otherQuestions || []).map(({ type, ...q }) => ({
        ...q,
        required: typeof q.required === 'boolean' ? q.required : false,
        options: Array.isArray(q.options)
          ? q.options.map(opt => {
              if (typeof opt === 'string') return { optionText: opt };
              if (opt && typeof opt === 'object' && 'optionText' in opt) return opt;
              return { optionText: String(opt) };
            })
          : [],
      }));
      // Validate generalQuestions (questionText and inputTypeId must both exist or both be empty)
for (let i = 0; i < normalizedOtherQuestions.length; i++) {
  const q = normalizedOtherQuestions[i];
  const hasQuestionText = q.questionText && q.questionText.trim() !== '';
  const hasInputTypeId = q.inputTypeId !== undefined && q.inputTypeId !== null && q.inputTypeId !== '';

  if ((hasQuestionText && !hasInputTypeId) || (!hasQuestionText && hasInputTypeId)) {
    userService.showNotification({
      title: "Validation Error",
      message: `Please fill both Question and Type`,
      type: "warning",
    });
    this.state.spinner.setAttribute("hidden", "true");
    return;
  }
}

      
      // Build domainQuestions
      const domains = this.state.domains.map((domain, i) => ({
        domainId: domain.domainid,
        questions: normalizedDomainQuestions[i] || []
      }));
    
      // Construct payload
      const payload = {
        title: this.state.surveyTitle,
        description: this.state.surveyDescription,
        introText: this.state.introText,
        endText: this.state.closingText,
        dpId:this.state.dischargePlannerId,
        domainQuestions: domains,
        generalQuestions: { questions: normalizedOtherQuestions },
      };
    
  
      console.log("payload", payload);
    
      // Append the acting facility so the backend ActingContext can resolve it — required for
      // Org Admins (who have no dischargeplanner row); without it facility_id saves as null.
      let apiUrl = apiPath.PostSurveyForm;
      const __fid = getActiveFacilityId();
      if (__fid) apiUrl += (apiUrl.indexOf("?") > -1 ? "&" : "?") + "facilityId=" + __fid;
      let showNotification = {};
    
      try {
        const response = await fetch(apiUrl, {
          method: "POST",
          headers: {
            ...generalAuthTokenHeader(),
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        });
    
        if (response.status === 400) {
          showNotification = { title: "Survey", message: "Bad Request", type: "danger" };
        } else if (response.status === 401) {
          userService.logout();
          window.location.reload(true);
        } else if (!response.ok) {
          showNotification = { title: "Survey", message: "Error submitting survey", type: "danger" };
        } else {
          showNotification = { title: "Survey", message: "Survey created successfully!", type: "success" };
          this.setState({ modalStatus: false });
          window.location.reload(true);
        }
    
        if (showNotification.title) userService.showNotification(showNotification);
      } catch (error) {
        console.error("Error submitting survey", error);
        userService.showNotification({ title: "Survey", message: "Server Error", type: "danger" });
      }
    
      this.state.spinner.setAttribute("hidden", "true");
    }
    previewSurveyForm = async () => {
      // Show spinner
      if (this.state.spinner) {
        this.state.spinner.removeAttribute("hidden");
      }
    
      // Clone existing domainQuestions
      const updatedDomainQuestions = [...this.state.domainQuestions];
    
      // Update either otherQuestions or domainQuestions based on currentDomainIndex
      if (this.state.currentDomainIndex === this.state.domains.length) {
        // Last domain: update otherQuestions
        await new Promise(resolve => {
          this.setState({ otherQuestions: this.state.questions }, resolve);
        });
      } else {
        // Update domain-specific questions
        updatedDomainQuestions[this.state.currentDomainIndex] = this.state.questions;
      }
    
      // Normalize domain questions
      const normalizedDomainQuestions = updatedDomainQuestions.map((domainQuestions = [], domainIndex) =>
        domainQuestions.map(({ type, ...q }) => ({
          ...q,
          required: domainIndex === 0 ? false : (typeof q.required === 'boolean' ? q.required : false),
          inputTypeName: q.inputTypeName || '', 
          options: Array.isArray(q.options)
            ? q.options.map(opt => {
                if (typeof opt === 'string') return { optionText: opt };
                if (opt && typeof opt === 'object' && 'optionText' in opt) return opt;
                return { optionText: String(opt) };
              })
            : [],
        }))
      );
    
      // Normalize other (general) questions
      const normalizedOtherQuestions = (this.state.otherQuestions || []).map(({ type, ...q }) => ({
        ...q,
        required: typeof q.required === 'boolean' ? q.required : false,
        inputTypeName: q.inputTypeName || '', 
        options: Array.isArray(q.options)
          ? q.options.map(opt => {
              if (typeof opt === 'string') return { optionText: opt };
              if (opt && typeof opt === 'object' && 'optionText' in opt) return opt;
              return { optionText: String(opt) };
            })
          : [],
      }));
    
      // Construct domain structure with questions
      const domains = this.state.domains.map((domain, i) => ({
        domainId: domain.domainid,
        questions: normalizedDomainQuestions[i] || [],
      }));
    
      // Construct preview payload
      const payload = {
        title: this.state.surveyTitle,
        description: this.state.surveyDescription,
        introText: this.state.introText,
        endText: this.state.closingText,
        dpId: this.state.dischargePlannerId,
        domainQuestions: domains,
        generalQuestions: { questions: normalizedOtherQuestions },
      };
    
      console.log("payload", payload);
    
      this.setState({
        previewPayload: payload,
        showPreview: true,
      });
    
      // Hide spinner
      if (this.state.spinner) {
        this.state.spinner.setAttribute("hidden", "true");
      }
    };
    
    
    goToNextDomain = () => {
       const isValid = this.validateQuestions();
  if (!isValid) {
    console.log("Validation failed, cannot move to next domain");
    return; // stop if validation fails
  }
      const { currentDomainIndex, domains } = this.state;
    
      // If already on the last domain (Other Domain), do nothing
      if (currentDomainIndex >= domains.length) {
        return;
      }
    
      if (this.state.questions.length === 0) {
        return;
      }
    
      const { questions, domainQuestions, otherQuestions } = this.state;
      const updatedDomainQuestions = [...domainQuestions];
      let updatedOtherQuestions = otherQuestions;
    
      // Save current questions
      if (currentDomainIndex === domains.length) {
        updatedOtherQuestions = questions;
      } else {
        updatedDomainQuestions[currentDomainIndex] = questions;
      }
    
      const nextDomainIndex = currentDomainIndex + 1;
    
      // Load next questions
      let nextQuestions;
      if (nextDomainIndex === domains.length) {
        const otherQs = updatedOtherQuestions || [];
        nextQuestions = otherQs.length > 0
          ? otherQs
          : [{ questionText: '', inputTypeId: null, options: [], weightage: 0, required: false }];
      } else {
        const domainQs = updatedDomainQuestions[nextDomainIndex] || [];
        nextQuestions = domainQs.length > 0
          ? domainQs
          : [{ questionText: '', inputTypeId: null, options: [], weightage: 0, required: false }];
      }
    
      this.setState({
        currentDomainIndex: nextDomainIndex,
        domainQuestions: updatedDomainQuestions,
        otherQuestions: updatedOtherQuestions,
        questions: nextQuestions.map((q, i) => ({ ...q, order: i + 1 })),
      });
    };
    
    removeQuestion = (index) => {
      const newQuestions = [...this.state.questions];
      newQuestions.splice(index, 1);
    
      // Recalculate questionOrder after removal
      const reorderedQuestions = newQuestions.map((q, idx) => ({
        ...q,
        questionOrder: idx + 1,
      }));
    
      const updatedDomainQuestions = [...this.state.domainQuestions];
      updatedDomainQuestions[this.state.currentDomainIndex] = reorderedQuestions;
    
      this.setState({
        questions: reorderedQuestions,
        domainQuestions: updatedDomainQuestions
      });
    };
    

    
  render() {
    const errorSource =
  this.state.currentDomainIndex === this.state.domains.length
    ? this.state.otherErrors
    : this.state.errors;

    return (
      <div>
        {/* Add button to trigger modal */}
       
            <div className="button-cover">
              <Button className="pointer btn1" onClick={this.openSurveyModal} style={{ color: "white" }}>
              Add New Survey
                  </Button>
                </div>

                <Dialog
          open={this.state.modalStatus}
          maxWidth="xl" // Or 'lg', adjust as needed
          onClose={this.modalClose}
          TransitionComponent={Transition}
          aria-labelledby="survey-dialog-title"
          fullWidth={true} // Ensure the modal takes full width of the maxWidth
          fullScreen 
        >
          <DialogTitle color="success"  className={"cusCardTitle"} id="survey-dialog-title" style={{ color: "white" }}>
            Add New Survey
          
            <IconButton
              className="closeButton"
              aria-label="close"
              onClick={this.modalClose}
              style={{ color: "white" }}
            >
              {/* <CloseIcon /> */}
            <img src={close} alt="" srcset=""  />
            </IconButton>

          </DialogTitle>
          


          <DialogContent>
          <Box>
          <div style={{ display: 'flex', marginBottom: '20px',justifyContent: 'center' }}>
            {(this.state.domains.concat([{ name: 'Other Domain' }])).map((domain, index, allDomains) => {
              const isOtherDomain = domain.name === 'Other Domain';
              const prevDomainQuestions = this.state.domainQuestions[index - 1];

              const isDisabled = index > 0 && (!prevDomainQuestions || prevDomainQuestions.length === 0);

              const domainIconsByIndex = [
                medication,        // index 0
                functionStatus,    // index 1
                congnitive,        // index 2
                pain,              // index 3
                social,            // index 4
                other              // index 5
              ];

              const isActive = this.state.currentDomainIndex === index;

              return (
                <div
                  key={index}
                  disabled={isDisabled}
                  onClick={() => {
                    if (isDisabled) return;

                    const updatedDomainQuestions = [...this.state.domainQuestions];

                    if (this.state.currentDomainIndex === allDomains.length - 1) {
                      this.setState({ otherQuestions: this.state.questions });
                    } else {
                      updatedDomainQuestions[this.state.currentDomainIndex] = this.state.questions;
                    }

                    let nextQuestions;
                    if (isOtherDomain) {
                      const questions = this.state.otherQuestions?.length > 0
                        ? this.state.otherQuestions
                        : [{
                            questionText: '',
                            inputTypeId: null,
                            options: [],
                            weightage: 0,
                            required: false
                          }];

                      nextQuestions = questions.map((q, i) => ({
                        ...q,
                        questionOrder: i + 1
                      }));
                    } else {
                      const questions = updatedDomainQuestions[index]?.length > 0
                        ? updatedDomainQuestions[index]
                        : [{
                            questionText: '',
                            inputTypeId: null,
                            options: [],
                            weightage: 0,
                            required: false
                          }];

                      nextQuestions = questions.map((q, i) => ({
                        ...q,
                        questionOrder: i + 1
                      }));
                    }

                    this.setState({
                      currentDomainIndex: index,
                      domainQuestions: updatedDomainQuestions,
                      questions: nextQuestions
                    });
                  }}
                 style={{border:'none'}}
                >
                  {isActive && (
                    <img 
                      src={domainIconsByIndex[index]} 
                      alt={domain.name} 
                    />
                  )}
                </div>
              );
            })}
          </div>


        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
     <input
  type="text"
  placeholder="Form Name"
  value={this.state.surveyTitle}
  onChange={this.handleTitleChange}
  style={{
    width: '33.33%',
    marginBottom: '10px',
    border: '1px solid #ccc',
    borderRadius: '8px',
    padding: '10px',
    height: '40px'
  }}
/>

<textarea
  placeholder="Form description"
  value={this.state.surveyDescription}
  onChange={this.handleDescriptionChange}
  style={{
    width: '66%',
    resize: 'none',
    marginLeft: '10px',
    border: '1px solid #ccc',
    padding: '10px',
    marginBottom: '20px',
    borderRadius: '8px',
    height: '40px'
  }}
/>
{/* {this.state.formErrors?.surveyDescription && (
  <span style={{ color: 'red', fontSize: '12px' }}>
    {this.state.formErrors.surveyDescription}
  </span>
)} */}

        </div>
        {this.state.formErrors?.surveyTitle && (
  <span style={{ color: 'red', fontSize: '12px' }}>
    {this.state.formErrors.surveyTitle}
  </span>
)}

            <DragDropContext onDragEnd={this.onDragEnd} >
              <Droppable droppableId="questions-droppable">
                {(provided) => (
                  <div {...provided.droppableProps} ref={provided.innerRef}>
                    {this.state.questions.map((q, qIndex) => (
                      <Draggable key={qIndex} draggableId={`question-${qIndex}`} index={qIndex}>
                        {(provided, snapshot) => (
                          <div
                            ref={provided.innerRef}
                            {...provided.draggableProps}
                            {...provided.dragHandleProps}
                            style={{
                              ...provided.draggableProps.style,
                              userSelect: 'none',
                              background: snapshot.isDragging ? '#f5f5f5' : 'white',
                              marginBottom: '30px',
                              border: '1px solid #ccc',
                              paddingBottom: '20px',
                              borderRadius: '8px',
                              padding: '10px'
                            }}
                          >
                            <h3 style={{ display: 'flex', alignItems: 'center', marginTop: '0px' , width: '100%', justifyContent: 'space-between'}}>
                              {/* <span style={{ marginRight: '10px', cursor: 'grab' }}>☰</span> */}
                              <div>
                                <img src={navbar} alt="" srcset="" style={{cursor: 'grab'}}/>
                                <span style={{ color: '#555555',/* Question 1 */fontWeight: 500,
                                  fontSize: '24px',
                                  paddingLeft: '10px'

                                  }}>Question {qIndex + 1}</span> 

                              </div>
                              <div>
                                  { qIndex >=1 && (
                                  <button
                                  onClick={() => this.removeQuestion(qIndex)}
                                  style={{
                                    background: 'transparent',
                                    border: 'none',
                                    color: 'red',
                                    cursor: 'pointer',
                                    fontSize: '18px'
                                  }}
                                  title="Remove Question"
                                  >
                                    <img src={deleteIcons} alt="" srcset="" style={{ paddingLeft: '10px' }}/>
                                  </button>
                                  )} 
                              </div>
                            
                            </h3>
                            <input
                              type="text"
                              placeholder={` Question ${qIndex + 1}`}
                              value={q.questionText}
                              onChange={e => this.handleQuestionChange(qIndex, e)}
                              style={{ width: '100%',  border: '1px solid #ccc',
                              padding: '10px',
                              marginBottom: '20px',
                              borderRadius: '8px',
                              height: '40px' }}
                            />
                      {errorSource?.[qIndex]?.questionText && (
  <span style={{ color: 'red', fontSize: '12px' }}>
    {errorSource[qIndex].questionText}
  </span>
)}

                                        <div style={{ marginTop: '10px' }}>
                            <label style={{ marginRight: '10px' }}>Type:</label> <br />
                            <select
                              value={q.type || ''}
                              onChange={e => this.handleTypeChange(qIndex, e)}
                              style={{ width: '25%',  border: '1px solid #ccc',
                              padding: '10px',
                              marginBottom: '20px',
                              borderRadius: '8px',
                              height: '40px' }}
                            >
                              <option value="">Select Type</option>
                              {this.state.surveys.map((type, index) => (
                                <option key={index} value={type.type}>
                                  {type.name}
                                </option>
                              ))}
                            </select>
                           
                          </div>

             {errorSource?.[qIndex]?.type && (
  <span style={{ color: 'red', fontSize: '12px' }}>
    {errorSource[qIndex].type}
  </span>
)}


                          {(q.type === 'Multiple Choice' || q.type === 'Exclusive Choice') &&
                          
                            q.options.map((option, oIndex) => {
                              // Extract the option text whether it's an object or string
                              const optionValue = typeof option === 'object' ? option.optionText : option;
                              
                              return (
                                <div key={oIndex} style={{ marginTop: '10px', display: 'flex', alignItems: 'flex-start' }}>
                                  <input
                                    type="text"
                                    placeholder={`Option ${oIndex + 1}`}
                                    value={optionValue}
                                    onChange={e => this.handleOptionChange(qIndex, oIndex, e)}
                                    style={{ width: '25%',border: '1px solid #ccc',
                                    padding: '10px',
                                    marginBottom: '20px',
                                    borderRadius: '8px',
                                    height: '40px'  }}
                                  />
                                  {q.options.length > 1 && (
                                    <button
                                      onClick={() => this.removeOption(qIndex, oIndex)}
                                      style={{
                                        background: 'transparent',
                                        border: 'none',
                                        color: 'red',
                                        cursor: 'pointer',
                                        fontSize: '18px'
                                      }}
                                      title="Remove Option"
                                    >
                                      <img src={deleteIcons} alt="" srcset="" style={{ paddingLeft: '10px' }}/>
                                    </button>
                                  )}
                                </div>
                              );
                            })
                          }

                          {errorSource?.[qIndex]?.options && (
  <div style={{ color: 'red', fontSize: '12px', marginBottom: '5px' }}>
    {errorSource[qIndex].options}
  </div>
)}

                            {(q.type === 'Multiple Choice' || q.type === 'Exclusive Choice') && (
                              <button
                                onClick={() => this.addOption(qIndex)}
                                style={{ marginTop: '10px', background: '#F07DA8', color: 'white', border: 'none', padding: '10px', borderRadius: '4px', cursor: 'pointer' }}
                              >
                                 Add Option
                              </button>
                            )}

                            <div style={{ marginTop: '15px' }}>
                              <strong>Preview:</strong>
                              <div style={{ marginTop: '5px' }}>
                                {this.renderInputPreview(q.type, q.options, qIndex)}
                              </div>
                            </div>
                            {/* Question Weightage (Stars) */}
                                  <div style={{ marginTop: '10px' }}>
                                    <label style={{ marginRight: '10px' }}>Weightage (Stars 1-5):</label> <br />
                                    <select
                                      value={q.weightage}
                                      onChange={(e) => this.handleWeightageChange(qIndex, e)}
                                      style={{ width: '25%',border: '1px solid #ccc',
                                      padding: '10px',
                                      marginBottom: '20px',
                                      borderRadius: '8px',
                                      height: '40px'  }}
                                    >
                                      <option value={0}>0</option>
                                      <option value={1}>1</option>
                                      <option value={2}>2</option>
                                      <option value={3}>3</option>
                                      <option value={4}>4</option>
                                      <option value={5}>5</option>
                                    </select>
                                  </div>

                                  {/* Required toggle */}
                                  <div style={{ marginTop: '10px' }}>
                                    <label style={{ marginRight: '10px' }}>Required:</label>
                                    <input
                                      type="checkbox"
                                      checked={q.required}
                                      onChange={() => this.handleRequiredChange(qIndex)}
                                    />
                                  </div>

                          </div>
                        )}
                      </Draggable>
                    ))}
                    {provided.placeholder}
                  </div>
                )}
              </Droppable>
            </DragDropContext>

                      

                      {this.state.currentDomainIndex < this.state.domains.length && (
                        <div style={{ textAlign: 'center', marginTop: '20px' }}>
                            <button
                              onClick={this.goToNextDomain}
                              disabled={this.state.questions.length === 0}
                              style={{
                                // padding: '10px 20px',
                                cursor: this.state.questions.length === 0 ? 'not-allowed' : 'pointer',
                                color: '#fff',
                                border: 'none',
                                borderRadius: '20px',
                                padding: '10px',
                                width: '100px',background: '#01A7A6', color: 'white',margin: 'auto',fontWeight: 'bold'
                              }}>
                                {/* <img src={next} alt="" srcset="" /> */}

                                Next
                              </button>
                              
                        </div>
                              )}
                      </Box>
                    </DialogContent>
                    {/* <textarea
                      placeholder="Closing message (e.g., Thank you for your time!)"
                      value={this.state.closingText}
                      onChange={this.handleClosingTextChange}
                      style={{
                        width: '100%',
                        fontSize: '16px',
                        border: 'none',
                        borderTop: '1px solid #ccc',
                        marginTop: '30px',
                        paddingTop: '10px',
                        resize: 'none',
                        outline: 'none',
                        textAlign: 'center',
                        color: '#4caf50',
                      }}
                    /> */}

                    <DialogActions>
                      <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%',padding: '8px 24px' }}>
                        <div>
                            <button onClick={this.addQuestion}  style={{ marginTop: '10px', background: '#F07DA8', color: 'white', border: 'none', padding: '10px', borderRadius: '4px', cursor: 'pointer' , borderRadius : '20px', height: '40px', width: '125px', fontWeight: '500', fontSize: '14px'}}>
                              Add Question
                            </button>

                        </div>
                        <div>
                          <Button   className="pointer btn1 canclebtn" onClick={this.modalClose}  style={{background: '#A9A9A9', borderRadius: '20px', height: '40px'}}>
                            Cancel
                          </Button>
                          <Button
                            onClick={() => this.previewSurveyForm()}
                            color="default"
                            className="pointer btn1"
                            disabled={this.state.loading}
                            style={{ margin: '10px', background: '#F07DA8', color: 'white', border: 'none', padding: '10px', borderRadius: '4px', cursor: 'pointer' , borderRadius : '20px', height: '40px' }}
                          >
                            Preview
                          </Button>
                          <Button onClick={() => this.submitSurveyForm()}
                            color="primary"
                              className="pointer btn1"
                            disabled={this.state.loading}
                            style={{ margin: '10px', background: '#F07DA8', color: 'white', border: 'none', padding: '10px', borderRadius: '4px', cursor: 'pointer' , borderRadius : '20px', height: '40px' }}
                          >
                            {this.state.loading && (
                              <CircularProgress size={24} className="buttonProgress" color="secondary" />
                            )}
                            Submit 
                          </Button>

                        </div>
                      </div>
          </DialogActions>
          <Dialog
              open={this.state.showPreview}
              onClose={() => this.setState({ showPreview: false })}
              maxWidth="md"
              fullWidth
            >
              <DialogTitle>
                Preview Survey
                <IconButton
                  aria-label="close"
                  onClick={() => this.setState({ showPreview: false })}
                  style={{ position: "absolute", right: 8, top: 8 }}
                >
                  <CloseIcon />
                </IconButton>
              </DialogTitle>

              <DialogContent dividers>
                <SurveyGeneralPreview payload={this.state.previewPayload} />
              </DialogContent>

              <DialogActions>
                <Button onClick={() => this.setState({ showPreview: false })} color="primary">
                  Close
                </Button>
              </DialogActions>
            </Dialog>


        </Dialog>
       

      </div>
    );
  }
}

export default AddNewSurvey;
